import apiService from './api';

export interface DirectorySubmissionModuleData {
  project_context: {
    brand: string;
    description: string;
    keywords: string[];
    website_url: string;
    address: string;
    phone: string;
    email: string;
    operating_hours: string;
    primary_business?: string;
  };
  platforms: {
    platform_name: string;
    platform_url: string;
    da_score: number;
  }[];
  is_new_website: boolean;
  domain_age_months: number;
}

export interface DirectorySubmissionGenerationRequest {
  platform_names: string[];
}

export interface DirectorySubmissionGenerationResponse {
  generation_id: string;
  status: string;
}

export interface DirectorySubmissionItem {
  id: string;
  status: string;
  title?: string;
  short_description?: string;
  long_description?: string;
  website_url?: string;
  category?: string;
  tags?: string[];
  published_platforms?: string[];
  is_user_modified: boolean;
  generated_at?: string;
}

export interface DirectorySubmissionEditRequest {
  title?: string;
  short_description?: string;
  long_description?: string;
  website_url?: string;
  category?: string;
  tags?: string[];
  published_platforms?: string[];
}

export async function getModuleData(): Promise<DirectorySubmissionModuleData> {
  return await apiService.request<DirectorySubmissionModuleData>(
    '/directory-submission/module-data',
    { method: 'GET' }
  );
}

export async function generateContent(payload: DirectorySubmissionGenerationRequest): Promise<DirectorySubmissionGenerationResponse> {
  return await apiService.request<DirectorySubmissionGenerationResponse>(
    '/directory-submission/generate-content',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}

export async function getGeneratedListings(generationId: string): Promise<DirectorySubmissionItem[]> {
  return await apiService.request<DirectorySubmissionItem[]>(
    `/directory-submission/generated/${encodeURIComponent(generationId)}`,
    { method: 'GET' }
  );
}

export async function getAllListings(): Promise<DirectorySubmissionItem[]> {
  return await apiService.request<DirectorySubmissionItem[]>(
    '/directory-submission/listings',
    { method: 'GET' }
  );
}

export async function updateListing(listingId: string, payload: DirectorySubmissionEditRequest): Promise<DirectorySubmissionItem> {
  return await apiService.request<DirectorySubmissionItem>(
    `/directory-submission/listings/${encodeURIComponent(listingId)}`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    }
  );
}
